import React, { ChangeEvent, useEffect, useState } from "react";
import { ErrorMessage, Field, useField, useFormikContext } from "formik";
import { useReactiveVar } from "@apollo/client";
import { currencySingVar } from "@me-team/host/main/globalVar/state";

interface PriceInputProps {
    name: string;
    placeholder: string;
    initialValue?: number | string;
    id: string;
    disabled?: boolean;
    classWrapperField?: string;
}

const PriceInput: React.FC<PriceInputProps> = ({
    name,
    placeholder,
    initialValue,
    id,
    disabled,
    classWrapperField,
}) => {
    const currencySing = useReactiveVar(currencySingVar);
    const { setFieldValue, setFieldTouched } = useFormikContext();
    const [, meta] = useField(name);
    const [price, setPrice] = useState("");

    useEffect(() => {
        if (initialValue === undefined || initialValue === null || initialValue === "") {
            setPrice("");
            return;
        }
        if (typeof initialValue === "number") {
            setPrice(initialValue.toFixed(2));
            return;
        }
        setPrice(initialValue);
    }, [initialValue]);

    const handlePriceChange = (e: ChangeEvent<HTMLInputElement>) => {
        e.preventDefault();
        const value = e.target.value.trim();
        const regex = /^(?!0\d)\d{0,6}(\.\d{0,2})?$/;
        if (regex.test(value) || value === "") {
            setPrice(value);
        }
    };

    const handleBlurPrice = (e: ChangeEvent<HTMLInputElement>) => {
        const value = e.target.value.trim();
        if (value === "") {
            setPrice("");
            setFieldTouched(name, true, true);
            setFieldValue(name, null);
        } else {
            const numericPrice = parseFloat(value);

            if (!isNaN(numericPrice)) {
                const formattedPrice = numericPrice.toFixed(2);
                setPrice(formattedPrice);
                setFieldValue(name, parseFloat(formattedPrice));
            } else {
                setPrice("");
                setFieldValue(name, null);
            }
        }
    };

    return (
        <div className={`position-relative ${classWrapperField}`}>
            <Field
                name={name}
                type="text"
                id={id}
                placeholder={placeholder}
                value={price !== null ? price.toString() : ""}
                className={`form-control ${meta.touched && meta.error ? "is-invalid" : ""}`}
                onBlur={handleBlurPrice}
                onChange={handlePriceChange}
                disabled={disabled}
            />
            <i
                className={`position-absolute fs-7 end-0 top-50 translate-middle-y text-dark me-3
             ${meta.touched && meta.error ? "d-none" : ""}`}
            >
                {currencySing}
            </i>
            <ErrorMessage name={name}>{(msg) => <div className="invalid-feedback">{msg}</div>}</ErrorMessage>
        </div>
    );
};

export default PriceInput;
